module.exports = __webpack_public_path__ + "img/icon_star_rate_inactive.3c1d9894.svg";